import { configureStore } from "@reduxjs/toolkit";
import getUserDetailReducer from "./GetUserDetail/slice";
import authUserReducer from "./Auth/slice";
import countryReducer from "./Countries/slice";
import companyDetailsReducer from "./Company/slice";
import assessmentListReducer from "./AssessmentList/slice";
import appliedJobReducer from "./AppliedJobsList/slice";

const store = configureStore({
  reducer: {
    getUserDetails: getUserDetailReducer,
    authUser: authUserReducer,  
    countries: countryReducer,
    companyDetails: companyDetailsReducer,
    assesmentList: assessmentListReducer,
    appliedjob: appliedJobReducer,

    // Add other reducers here if needed
  },
});

export default store;


